import EquipmentPassportTree from '../../EquipmentFormFields/EquipmentPassportTree'
import EquipmentPassportValuesForm from '../../EquipmentFormFields/EquipmentPassportValuesForm'
import useEquipmentForm from '../../EquipmentFormFields/hooks/useEquipmentForm'
import css from '../equipmentViewingStepsContent.module.css'

interface IProps {
  ctrl: ReturnType<typeof useEquipmentForm>
}

const EquipmentPassportEditingStep = (props: IProps) => {
  return (
    <div
      className="inline-flex-gap gap24 height100"
      style={{ minHeight: 0, overflow: 'auto', flex: '1 1 0%', paddingRight: '18px' }}
    >
      <div className={css.passportNavBlock}>
        <EquipmentPassportTree
          passportSchemaId={props.ctrl.passport.passportSchemaId}
          selectCtrl={props.ctrl.groupSelectCtrl}
          handleSelect={props.ctrl.handlePassportGroupSelect}
        />
      </div>
      <EquipmentPassportValuesForm
        passportSchemaId={props.ctrl.passport.passportSchemaId}
        onChange={props.ctrl.handlePassportValueUpdate}
        values={props.ctrl.passport.values}
        onGroupIntoViewportChange={props.ctrl.groupSelectCtrl.handleSelect}
      />
    </div>
  )
}

export default EquipmentPassportEditingStep
